module.exports = __webpack_public_path__ + "img/logo-proAct.8195d765.svg";